import { get } from "lodash";
import ISTCountries from "./IST/countries";

const getters = {
  reasons: (state) => state.reasons,
  piiAuthorizationStatus: (state) => state.piiAuthorizationStatus,
  isPiiAuthActive: (state) => state.piiAuthorizationStatus === "active",
  currentAuthorization: (state) => state.current_authorization,
  markets: (state) => state.markets,
  reason: (state) => (id) => state.reasons.find((reason) => reason.id === id),
  ISTFormOpen: (state) => state.helpers.isISTOpen,
  countries: (state) => {
    return state.helpers.isISTOpen ? ISTCountries : state.countries;
  },
  countryStates: (state, getter) => (countrySName) =>
    get(getter.countries, [countrySName, "states"], {}),
  permissions: (state) => state.permissions,
  feature_flags: (state) => state.feature_flags,
  roles: (state) => state.roles,
  groups: (state) => state.groups,
  products: (state) => get(state, "products", []),
  devices: (state) => {
    return state.products.filter((prod) => {
      if (prod.device) {
        return Boolean(!prod.is_accessory);
      } else {
        return false;
      }
    });
  },
  accessories: (state) => {
    return state.products.filter((prod) => {
      if (prod.device) {
        return Boolean(prod.is_accessory);
      } else {
        return false;
      }
    });
  },
  userHasPermission:
    (state, _getters, _rootState, rootGetter) =>
    ({ permission, on }) => {
      const resource = on;
      const user = rootGetter["auth/user"] || {};
      const acl = user.acl || {};

      // If no ACL or no resource in ACL, return false
      if (!acl || !acl[resource]) {
        return false;
      }

      // Check if the specific permission exists
      return Boolean(acl[resource][permission]);
    },

  delayedFulfillmentEnabled: (state, getter) => {
    return getter.userHasPermission({
      permission: "view-feature",
      on: "DelayedFulfillment",
    });
  },
  delayedFulfillmentTipsEnabled: (state, getter) => {
    return getter.userHasPermission({
      permission: "view-tips",
      on: "DelayedFulfillment",
    });
  },
  retailers: (state) => state.retailers,
  readMessage: (state) => (id) => {
    const msg = get(state.messages, id, null);
    if (msg) delete state.messages[id];
    return msg;
  },
};

export default getters;
